import messaging from '@/locales/en/messaging/messaging.locales';

export default {
    ...messaging,
};
